import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedItem, setSelectedRows, setSelectAll } from '../../components/PerinHealthGridSlice';
import { resetFilterState } from '../../slicers/FilterSlice';
import PerinHealthGrid from '../../components/PerinHealthGrid';
import FilterManagementView from '../../components/FilterManagementView';
import managementStyles from '../ManagementPages.module.css';
import { showAlert } from '../../components/PerinHealthAlertSlice';
import { closeModal } from '../../components/PerinHealthModelSlice';
import styles from './HubManagement.module.css';
import useAxios from '../../services/AxiosConfig';
import { formatDateString } from '../../utils/dateUtils';
import { setUpdatingHub, resetHubState, setGroupsWithHubs } from './HubSlice';

const HubManagement = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const accountId = useSelector((state) => state.userInfo.id);
    const userDateFormat = useSelector((state) => state.userInfo.dateFormat);
    const uniqueGroups = useSelector((state) => state.userInfo.uniqueGroups);
    const perinHealthGrid = useSelector((state) => state.perinHealthGrid);
    let selectedRows = perinHealthGrid.selectedRows;
    
    useEffect(() => {
        dispatch(resetFilterState());
        dispatch(setSelectedRows([]));
        dispatch(setSelectedItem({}));
        dispatch(resetHubState());
    }, [dispatch]);

    const [hubData, setHubData] = useState([]);

    const axiosConfig = useSelector((state) => state.axiosConfig);
    const httpService = useAxios(axiosConfig.envURL);

    const headers = [
        { key: 'groupName', label: "Group" },
        { key: 'quantity', label: "Quantity" },
        { key: 'numAssigned', label: "Assigned" },
    ];

    const getTotalHubs = () => {
        let total = 0;
        hubData.forEach((item)=> {
            total += item.quantity;
        });
        return total;
    };

    const totalHubsAssigned = getTotalHubs();

    const getTotalAssignedHubs = () => {
        let totalAssigned = 0;
        hubData.forEach((item) => {
            totalAssigned += item.numAssigned;
        });
        return totalAssigned;
    };

    const totalAssignedHubs = getTotalAssignedHubs();

    // Every group already has a hub row, so there's nothing left to add.
    const addHubDisabled = uniqueGroups.length > 0 && hubData.length >= uniqueGroups.length;

    useEffect(() => {
        getHubs();
    }, [userDateFormat]);

    const onGroupNameClickHandler = (group) => {
        navigate('/hub-management-patient', { state: { groupName: group.groupName, groupId: group.groupId  } });
    };

    const getHubs = async () => {
        dispatch(resetFilterState());
        httpService.get(`hub/group/${accountId}`)
          .then((responseData) => {
            if (Array.isArray(responseData.data.data)) {
              const formattedHubs = responseData.data.data.map(hub => ({
                ...hub,
                genesis: hub.genesis ? formatDateString(hub.genesis, userDateFormat) : "-"
              }));
              setHubData(formattedHubs);
              dispatch(setGroupsWithHubs(responseData.data.data.map((group) => group.groupId)));
            } else {
              console.error('Invalid data format:');
            }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const onUpdateHubHandler = (group) => {
        dispatch(setUpdatingHub({
            ...group,
            hubs: group.hubs || []
        }));
        navigate('/add-hub');
    };


    return (
       
            <div className={managementStyles.MiddleContent}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <span className={styles.HubsNumber}>{totalAssignedHubs}</span>
                    <span className={styles.HubsLabel}>/{totalHubsAssigned}</span>
                    <span className={styles.HubsLabel} style={{ color: "#30584A", paddingLeft: "5px" }}>Hubs Assigned</span>
                </div>
                <FilterManagementView
                    isOrganization={true}
                    isGroup={true}
                    addButtonLabel='Add Hub'
                    onAddHandler={() => navigate('/add-hub')}
                    addDisabled={addHubDisabled}
                    showDeleteButton={false}
                />
                <div className={managementStyles.GridContainer}>
                <PerinHealthGrid
                    dataList={hubData}
                    headers={headers}
                    showCheckbox={false}
                    onRowValueClick={onGroupNameClickHandler}
                    showEditIcon={true}
                    onRowClick={onUpdateHubHandler}
                    gridHeight='100%'
                    rowValueAction={'groupName'} 
                />     
                </div>
            </div>
    );
}

export default HubManagement;